import { Popover, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../../../../../Icon"
import { EVIDENCE_CLASSIFICATIONS, EVIDENCE_STRENGTHS } from "../../schema/evidenceGuidance"

import styles from "./questionField.module.less"

const { Text } = Typography

const GUIDANCE_ROWS = [
  ["Description", (g) => g.description],
  ["Why it matters", (g) => g.whyItMatters],
  ["Supports", (g) => g.supports],
  ["Classification", (g) => EVIDENCE_CLASSIFICATIONS[g.classification] || g.classification],
  ["Strength", (g) => EVIDENCE_STRENGTHS[g.strength] || g.strength],
  ["Collection guidance", (g) => g.collection]
]

// Onboarding guidance for an evidence type: a "Guidance" chip that pops the five-field
// reference so a merchant knows what to provide and why it helps.
const GuidanceTag = ({ guide }) => {
  const { t } = useTranslation()
  return (
    <Popover
      placement="rightTop"
      arrow={false}
      trigger="hover"
      mouseEnterDelay={0.12}
      mouseLeaveDelay={0.12}
      getPopupContainer={() => document.getElementById("main-layout") || document.body}
      overlayClassName={styles.guidancePop}
      content={
        <div className={styles.guidance}>
          {GUIDANCE_ROWS.map(([label, get]) => (
            <div className={styles.guidanceRow} key={label}>
              <Text className={styles.guidanceK}>{t(label)}</Text>
              <Text className={styles.guidanceV}>{t(get(guide))}</Text>
            </div>
          ))}
        </div>
      }
    >
      <span className={`${styles.exampleTag} dq-guidance-tag`}>
        <Icon type="circle_info_simple" />
        {t("Guidance")}
      </span>
    </Popover>
  )
}

export default GuidanceTag
